import { action } from '@ember/object';
import Route from '@ember/routing/route';

export default class ApplicationLoadingRoute extends Route {
  /**
   * Needed because doRefresh is bubbled up in rates and ranking controller, when the route is not neccesarily active.
   * This will stop the propagation and prevent an error.
   */
  @action
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  doRefresh() {
    return false;
  }
}
